import { useState } from 'react'
import VehicleForm from '../../../components/vehicle/VehicleForm'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

const CreateNewVehicle = () => {
  const [vehicleDetails, setVehicleDetails] = useState({})

  return (
    <Tabs variant="fullWidth" style={{ width: '100%' }}>
      <TabList style={{ fontSize: '1.25rem' }}>
        <Tab>Vehicle Details</Tab>
      </TabList>

      <TabPanel>
        <div className="w-full bg-tracer-dark-blue text-white ">
          <VehicleForm
            vehicleDetails={vehicleDetails}
            setVehicleDetails={setVehicleDetails}
          />
        </div>
      </TabPanel>
    </Tabs>
  )
}

export default CreateNewVehicle
